module.exports = __webpack_public_path__ + "img/gray-dark-01-mini.1d853af9.png";